import { APPLICATION_ROUTES } from '@philips-emr/hpms-provider-accreditation-commons';
import { applicationModuleRegistry } from '@philips-emr/tws-foundation';

export function setupTechnical(): void {

  applicationModuleRegistry.register({
    entry: 'technical-visit',
    id: 'technical-visit',
    name: 'pa.technical-visit',
    route: APPLICATION_ROUTES.TECHNICAL_VISIT,
    order: 2,
  });
}
